import React from 'react';

export interface IconGastroProps {
  className?: string;
  size?: number | string;
  color?: string;
  fill?: string;
  stroke?: string;
}

const IconGastro: React.FC<IconGastroProps> = ({ 
  className = '', 
  size = 24, 
  color = 'currentColor', 
  fill, 
  stroke 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      color={color}
      fill={fill || 'none'}
    >
       <path d="M6 3V6.91304C6 8.20983 7.07441 9.26087 8.40003 9.26087C9.72484 9.26087 10.8001 8.20983 10.8001 6.91304V3" stroke={stroke || "#020617"}  strokeWidth="1.5" strokeLinecap="square" /> <path d="M8.3999 3V21" stroke={stroke || "#020617"}  strokeWidth="1.5" strokeLinecap="square" /> <path d="M15.6001 9.26086V21" stroke={stroke || "#020617"}  strokeWidth="1.5" strokeLinecap="square" /> <path d="M13.1997 5.34783C13.1997 4.05183 14.2741 3 15.5997 3C16.9245 3 17.9998 4.05183 17.9998 5.34783V6.91304C17.9998 8.20983 16.9245 9.26087 15.5997 9.26087C14.2741 9.26087 13.1997 8.20983 13.1997 6.91304V5.34783Z" stroke={stroke || "#020617"}  strokeWidth="1.5" strokeLinecap="round" />  
    </svg>
  );
};

export default IconGastro;
